import React from 'react';
import {
    Title,
    ItemsContainer,
    Item
} from "../../CommonStyles";
import Row from '../../../Shared/Kit/Row';
import Col from '../../../Shared/Kit/Col';

const Section2 = () => {
    return (
        <>
            <Title>
                محل پروژه
            </Title>
            <ItemsContainer className="p-r">
                <Item>
                    <Row className="description">
                        <Col className="bullet" />
                        ضلع شمالی اتوبان تهران کرج، بین خیابان اردستانی و میدان دانش
                    </Row>
                </Item>
            </ItemsContainer>
        </>
    )
}

export default Section2;